import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function FinalCTABlock() {
  return <div className="text-center py-12" data-id="element-111">
      <motion.a href="https://stresslessdogs.nl/mc-communiceren" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="inline-block w-full bg-[#2563EB] text-white font-semibold text-lg md:text-xl py-5 px-8 rounded-lg shadow-lg hover:bg-blue-700 transition-colors mb-6" data-id="element-112">
        JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN
      </motion.a>

      <p className="text-gray-600 italic text-lg mb-8 font-medium" data-id="element-113">
        In 90 minuten van frustratie naar begrip, van gissen naar weten
      </p>

      <div className="flex flex-col items-center justify-center space-y-3" data-id="element-114">
        <div className="flex space-x-1" data-id="element-115">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" data-id="element-116" />)}
        </div>
        <p className="text-sm font-medium text-gray-500" data-id="element-117">
          Meer dan 100.000 deelnemers in 2024
        </p>
        <p className="text-[#2563EB] font-semibold mt-2 text-lg" data-id="element-118">
          Want soms kan anderhalf uur alles veranderen.
        </p>
      </div>
    </div>;
}